import type { SVGProps } from "react";

/**
 * GitHub glyph, vendored from lucide-react 0.564.
 *
 * lucide-react 1.x removed brand icons outright — there is no `GithubIcon`
 * export in 1.28.0 and no renamed equivalent — but the mark is still needed to
 * label GitHub affordances (the command palette's Reconnect GitHub button, the
 * palette's `github` result kind, and the repository row on a project). This
 * keeps the exact paths and SVG attributes lucide emitted, so the upgrade is a
 * dependency change rather than a visual one.
 *
 * Note this is lucide's stroked outline glyph, not GitHub's official filled
 * brand mark. That is deliberate: matching what shipped before matters more
 * here than switching to the official logo, which would be a visible redesign
 * of every site that renders it. If the official mark is wanted, that is a
 * design decision to make on its own.
 */
export function GithubIcon({ className, ...props }: SVGProps<SVGSVGElement>) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={24}
      height={24}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth={2}
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
      className={className}
      {...props}
    >
      <path d="M15 22v-4a4.8 4.8 0 0 0-1-3.5c3 0 6-2 6-5.5.08-1.25-.27-2.48-1-3.5.28-1.15.28-2.35 0-3.5 0 0-1 0-3 1.5-2.64-.5-5.36-.5-8 0C6 2 5 2 5 2c-.3 1.15-.3 2.35 0 3.5A5.403 5.403 0 0 0 4 9c0 3.5 3 5.5 6 5.5-.39.49-.68 1.05-.85 1.65-.17.6-.22 1.23-.15 1.85v4" />
      <path d="M9 18c-4.51 2-5-2-7-2" />
    </svg>
  );
}
